import React from "react";
import { useSelector } from "react-redux";
import MobileFooter from "./MobileFooter";
import FooterDesktop from "./FooterDesktop";
import "./footer.scss";

export default function Footer() {
  const isLsm = useSelector((state) => state.deviceSize.isLsm);

  return isLsm ? <MobileFooter /> : <FooterDesktop />;
}
